import { PageLayout } from "@/components/page-layout/PageLayout";
import * as React from "react";
import { Helmet } from "react-helmet";
import { StatisticsByRoutePairTable } from "../../components/StatisticsByRoutePairTable";
import { SearchFilterSelectorProvider } from "@/features/search-filter/context/searchFilterSelectorContext";

export const StatisticsByRoutePairListPanel: React.FC = () => {
  return (
    <>
      <Helmet title="Route - Statistics - FPP" />
      <PageLayout>
        <SearchFilterSelectorProvider
          reducerId={"statistics.statisticsByRoutePair"}
        >
          <StatisticsByRoutePairTable />
        </SearchFilterSelectorProvider>
      </PageLayout>
    </>
  );
};
